module.exports = __webpack_public_path__ + "media/favicon/safari-pinned-tab-eff47d1e.svg";